import Types from './cs.types';

export const INITIAL_STATE = {
  ratesAvrage: {
    loading: false,
    data: [],
  },
  csPercent: {
    loading: false,
    data: [],
  },
  ratesCount: {
    loading: false,
    data: [],
  },
  happyCustomers: {
    loading: false,
    data: [],
  },
  angryCustomers: {
    loading: false,
    data: [],
  },
  platformsStats: {
    loading: false,
    data: null,
  },
  usersStats: {
    loading: false,
    data: null,
  },
};

const conversationsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // show loading while fetching data
    case Types.LOADING_RATES_AVRAGE:
      return {
        ...state,
        ratesAvrage: {
          loading: action.payload,
          data: state.ratesAvrage.data,
        },
      };
    case Types.LOADING_CS_PERCENT:
      return {
        ...state,
        csPercent: {
          loading: action.payload,
          data: state.csPercent.data,
        },
      };

    case Types.LOADING_RATES_COUNT:
      return {
        ...state,
        ratesCount: {
          loading: action.payload,
          data: state.ratesCount.data,
        },
      };

    case Types.LOADING_HAPPY_CUSTOMERS:
      return {
        ...state,
        happyCustomers: {
          loading: action.payload,
          data: state.happyCustomers.data,
        },
      };

    case Types.LOADING_ANGRY_CUSTOMERS:
      return {
        ...state,
        angryCustomers: {
          loading: action.payload,
          data: state.angryCustomers.data,
        },
      };

    // set date in store
    case Types.SET_RATES_AVRAGE:
      return {
        ...state,
        ratesAvrage: {
          loading: false,
          data: action.payload,
        },
      };

    case Types.SET_CS_PERCENT:
      return {
        ...state,
        csPercent: {
          loading: false,
          data: action.payload,
        },
      };

    case Types.SET_RATES_COUNT:
      return {
        ...state,
        ratesCount: {
          loading: false,
          data: action.payload,
        },
      };

    case Types.SET_HAPPY_CUSTOMERS:
      return {
        ...state,
        happyCustomers: {
          loading: false,
          data: action.payload,
        },
      };

    case Types.SET_ANGRY_CUSTOMERS:
      return {
        ...state,
        angryCustomers: {
          loading: false,
          data: action.payload,
        },
      };

    case Types.FETCH_PLATFORMS_STATS_DATA:
      return {
        ...state,
        platformsStats: {
          ...state.platformsStats,
          loading: true,
        },
      };

    case Types.SET_PLATFORMS_STATS_DATA:
      return {
        ...state,
        platformsStats: {
          ...state.platformsStats,
          data: action.payload,
          loading: false,
        },
      };

    case Types.FETCH_USERS_STATS_DATA:
      return {
        ...state,
        usersStats: {
          ...state.usersStats,
          loading: true,
        },
      };

    case Types.SET_USERS_STATS_DATA:
      return {
        ...state,
        usersStats: {
          ...state.usersStats,
          data: action.payload,
          loading: false,
        },
      };

    default:
      return state;
  }
};

export default conversationsReducer;
